export default {
    data: {
        'login': 1,
        'message_cnt': '1',
        'max_mark_id': '2807795',
        'list': [
            {
                'id': '2927428',
                'pid': '2500670012230127100205749OI',
                'content': '有福字',
                'likenum': '2',
                'replynum': '0',
                'position': '河北省唐山市迁西县',
                'c_time': '1675858191',
                'mark_status': '1',
                'city_id': '265',
                'city': '唐山市',
                'province': '河北省',
                'district': '迁西县',
                'heading': '189.032',
                'pitch': '-10.042',
                'type': '4',
                'x': '0',
                'y': '0',
                'z': '0',
                'poi_desc': '北孙家峪村西北879米',
                'pid_type': '0',
                'uid': '',
                'richcontent': [
                    {
                        'type': 'text',
                        'value': '有福字'
                    }
                ],
                'is_delete': 0,
                'panourl': 'https://mapsv0.bdimg.com/?qt=pr3d&fovy=75&quality=75&width=300&height=300&panoid=2500670012230127100205749OI&heading=189.032&pitch=-10.042',
                'reply_count': 0,
                'mark_id': '2927428',
                'reply_id': '0'
            },
            {
                'id': '2926689',
                'pid': '22444400132003051702072997XX',
                'content': '真不错',
                'likenum': '1',
                'replynum': '0',
                'position': '福建省三明市永安市青水畲族乡龙头村',
                'c_time': '1675849596',
                'mark_status': '1',
                'city_id': '254',
                'city': '三明市',
                'province': '福建省',
                'district': '永安市',
                'heading': '153.787',
                'pitch': '-10.749',
                'type': '4',
                'x': '0',
                'y': '0',
                'z': '0',
                'poi_desc': '',
                'pid_type': '6',
                'uid': '96b672aa6e332a76cf04ef82',
                'richcontent': [
                    {
                        'type': 'text',
                        'value': '真不错'
                    }
                ],
                'is_delete': 0,
                'panourl': 'https://mapsv0.bdimg.com/?qt=pr3d&fovy=75&quality=75&width=300&height=300&panoid=22444400132003051702072997XX&heading=153.787&pitch=-10.749',
                'reply_count': 0,
                'mark_id': '2926689',
                'reply_id': '0'
            },
            {
                'id': '2925110',
                'pid': '22444400132012111223196557XX',
                'content': 'nice',
                'likenum': '0',
                'replynum': '0',
                'position': '北京市东城区天坛东里甲1号',
                'c_time': '1675821306',
                'mark_status': '2',
                'city_id': '131',
                'city': '北京市',
                'province': '',
                'district': '东城区',
                'heading': '113.784',
                'pitch': '7.136',
                'type': '4',
                'x': '0',
                'y': '0',
                'z': '0',
                'poi_desc': '',
                'pid_type': '6',
                'uid': '45ef9a2b5508cbfda2d230e6',
                'richcontent': [
                    {
                        'type': 'text',
                        'value': 'nice'
                    }
                ],
                'is_delete': 0,
                'panourl': 'https://mapsv0.bdimg.com/?qt=pr3d&fovy=75&quality=75&width=300&height=300&panoid=22444400132012111223196557XX&heading=113.784&pitch=7.136',
                'reply_count': 0,
                'mark_id': '2925110',
                'reply_id': '0'
            },
            {
                'id': '2923092',
                'pid': '22444400131902211550732501XX',
                'content': '好看啊',
                'likenum': '1',
                'replynum': '0',
                'position': '山东省青岛市',
                'c_time': '1675762213',
                'mark_status': '1',
                'city_id': '236',
                'city': '青岛市',
                'province': '',
                'district': '市南区',
                'heading': '322.525',
                'pitch': '84.411',
                'type': '4',
                'x': '0',
                'y': '0',
                'z': '0',
                'poi_desc': '',
                'pid_type': '6',
                'uid': 'cb3ecd91b973597a25e0a067',
                'richcontent': [
                    {
                        'type': 'text',
                        'value': '好看啊'
                    }
                ],
                'is_delete': 0,
                'panourl': 'https://mapsv0.bdimg.com/?qt=pr3d&fovy=75&quality=75&width=300&height=300&panoid=22444400131902211550732501XX&heading=322.525&pitch=84.411',
                'reply_count': 0,
                'mark_id': '2923092',
                'reply_id': '0'
            },
            {
                'id': '2824967',
                'pid': '22775380131812151544880471XX',
                'content': '挺高的',
                'likenum': '1',
                'replynum': '0',
                'position': '埃及开罗西南郊',
                'c_time': '1674125414',
                'mark_status': '5',
                'city_id': '77538',
                'city': 'El Haram',
                'province': '',
                'district': 'El Haram',
                'heading': '21.488',
                'pitch': '-9.617',
                'type': '4',
                'x': '0',
                'y': '0',
                'z': '0',
                'poi_desc': '',
                'pid_type': '6',
                'uid': '56c813ac5073da5cea56fa22',
                'richcontent': [
                    {
                        'type': 'text',
                        'value': '挺高的'
                    }
                ],
                'is_delete': 0,
                'panourl': 'https://mapsv0.bdimg.com/?qt=pr3d&fovy=75&quality=75&width=300&height=300&panoid=22775380131812151544880471XX&heading=21.488&pitch=-9.617',
                'reply_count': 0,
                'mark_id': '2824967',
                'reply_id': '0'
            },
            {
                'id': '2824960',
                'pid': '22444400132106250940120398XX',
                'content': '到此一游',
                'likenum': '1',
                'replynum': '0',
                'position': '捷克 Praha, Křižovnické nám.,',
                'c_time': '1674125334',
                'mark_status': '1',
                'city_id': '46663',
                'city': '布拉格',
                'province': '',
                'district': '布拉格',
                'heading': '12.364',
                'pitch': '3.761',
                'type': '4',
                'x': '0',
                'y': '0',
                'z': '0',
                'poi_desc': '',
                'pid_type': '6',
                'uid': '051c27cca9cfa740ca09f0bf',
                'richcontent': [
                    {
                        'type': 'text',
                        'value': '到此一游'
                    }
                ],
                'is_delete': 0,
                'panourl': 'https://mapsv0.bdimg.com/?qt=pr3d&fovy=75&quality=75&width=300&height=300&panoid=22444400132106250940120398XX&heading=12.364&pitch=3.761',
                'reply_count': 0,
                'mark_id': '2824960',
                'reply_id': '0'
            },
            {
                'id': '2824957',
                'pid': '22444400132106250940012584XX',
                'content': '可以的',
                'likenum': '1',
                'replynum': '0',
                'position': '捷克 Praha, Křižovnické nám.,',
                'c_time': '1674125299',
                'mark_status': '5',
                'city_id': '46663',
                'city': '布拉格',
                'province': '',
                'district': '布拉格',
                'heading': '23.966',
                'pitch': '-32.726',
                'type': '4',
                'x': '0',
                'y': '0',
                'z': '0',
                'poi_desc': '',
                'pid_type': '6',
                'uid': '051c27cca9cfa740ca09f0bf',
                'richcontent': [
                    {
                        'type': 'text',
                        'value': '可以的'
                    }
                ],
                'is_delete': 0,
                'panourl': 'https://mapsv0.bdimg.com/?qt=pr3d&fovy=75&quality=75&width=300&height=300&panoid=22444400132106250940012584XX&heading=23.966&pitch=-32.726',
                'reply_count': 0,
                'mark_id': '2824957',
                'reply_id': '0'
            },
            {
                'id': '2824631',
                'pid': '22444400132301071205387173XX',
                'content': '这地方有点老了',
                'likenum': '21',
                'replynum': '1',
                'position': '北京市海淀区西三旗东路运达实业公司内',
                'c_time': '1674121624',
                'mark_status': '1',
                'city_id': '131',
                'city': '北京市',
                'province': '',
                'district': '海淀区',
                'heading': '138.682',
                'pitch': '1.052',
                'type': '4',
                'x': '0',
                'y': '0',
                'z': '0',
                'poi_desc': '',
                'pid_type': '6',
                'uid': '57a82e8013a1009b8bf15df0',
                'richcontent': [
                    {
                        'type': 'text',
                        'value': '这地方有点老了'
                    }
                ],
                'is_delete': 0,
                'panourl': 'https://mapsv0.bdimg.com/?qt=pr3d&fovy=75&quality=75&width=300&height=300&panoid=22444400132301071205387173XX&heading=138.682&pitch=1.052',
                'reply_count': 1,
                'mark_id': '2824631',
                'reply_id': '0'
            },
            {
                'id': '2818319',
                'pid': '2300220012221004192004684OI',
                'content': '在这里吃过',
                'likenum': '1',
                'replynum': '0',
                'position': '北京市朝阳区',
                'c_time': '1674027499',
                'mark_status': '1',
                'city_id': '131',
                'city': '北京市',
                'province': '北京市',
                'district': '朝阳区',
                'heading': '2.673',
                'pitch': '-13.849',
                'type': '4',
                'x': '0',
                'y': '0',
                'z': '0',
                'poi_desc': '华人巨擘商务中心北57米',
                'pid_type': '0',
                'uid': '',
                'richcontent': [
                    {
                        'type': 'text',
                        'value': '在这里吃过'
                    }
                ],
                'is_delete': 0,
                'panourl': 'https://mapsv0.bdimg.com/?qt=pr3d&fovy=75&quality=75&width=300&height=300&panoid=2300220012221004192004684OI&heading=2.673&pitch=-13.849',
                'reply_count': 0,
                'mark_id': '2818319',
                'reply_id': '0'
            },
            {
                'id': '2807795',
                'pid': '22444400131908301567148953XX',
                'content': '这里很好看',
                'likenum': '1',
                'replynum': '0',
                'position': '湖北省神农架林区红坪镇',
                'c_time': '1673850488',
                'mark_status': '1',
                'city_id': '2734',
                'city': '神农架林区',
                'province': '湖北省',
                'district': '神农架林区',
                'heading': '182.426',
                'pitch': '-4.198',
                'type': '4',
                'x': '0',
                'y': '0',
                'z': '0',
                'poi_desc': '',
                'pid_type': '6',
                'uid': '61d5144b3ade6097882fb5db',
                'richcontent': [
                    {
                        'type': 'text',
                        'value': '这里很好看'
                    }
                ],
                'is_delete': 0,
                'panourl': 'https://mapsv0.bdimg.com/?qt=pr3d&fovy=75&quality=75&width=300&height=300&panoid=22444400131908301567148953XX&heading=182.426&pitch=-4.198',
                'reply_count': 0,
                'mark_id': '2807795',
                'reply_id': '0'
            }
        ]
    },
    errno: 0,
    errstr: 'ok'
};